var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_5253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.75C2.5 4.78562 4.73875 5.625 7.5 5.625C10.2613 5.625 12.5 4.78562 12.5 3.75C12.5 2.71438 10.2613 1.875 7.5 1.875C4.73875 1.875 2.5 2.71438 2.5 3.75Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.75V7.5C2.5 8.53562 4.73875 9.375 7.5 9.375M12.5 7.1875V3.75",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5V11.25C2.5 12.2856 4.73875 13.125 7.5 13.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.25C9.375 11.7473 9.57254 12.2242 9.92417 12.5758C10.2758 12.9275 10.7527 13.125 11.25 13.125C11.7473 13.125 12.2242 12.9275 12.5758 12.5758C12.9275 12.2242 13.125 11.7473 13.125 11.25C13.125 10.7527 12.9275 10.2758 12.5758 9.92417C12.2242 9.57254 11.7473 9.375 11.25 9.375C10.7527 9.375 10.2758 9.57254 9.92417 9.92417C9.57254 10.2758 9.375 10.7527 9.375 11.25Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 12.625L13.75 13.75",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_5253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.dd9ef927c44de263211225ada3123f7b.svg";
export { ForwardRef as ReactComponent };